import React from 'react';
import {
    TextField,
    MenuItem,
    Tooltip,
    Box,
    Stack,
    Fab,
    CircularProgress,
    IconButton
} from '@mui/material';
import SaveIcon from '@mui/icons-material/SaveAsOutlined';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import { green } from '@mui/material/colors';

const EditableSelect = ({
    title,
    value,
    options,
    loading,
    success,
    error,
    readOnly,
    onChange,
    onSave,
    onCancel,
    onKeyDown,
    isRequired,
}) => {
    const buttonSx = success && {
        bgcolor: green[500],
        '&:hover': {
            bgcolor: green[700],
        },
    };

    const isValueEmpty = value === '' || !options.some(opt => opt.value === value);

    return (
        <Tooltip title={isValueEmpty && isRequired ? "Value cannot be empty" : "Press Enter to Save, Esc to Cancel"} placement="top">
            <Stack direction="row" spacing={2} alignItems="center">
                <TextField
                    select
                    size="small"
                    label={title}
                    color={error ? "error" : "secondary"}
                    focused
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={onKeyDown}
                    disabled={loading}
                    inputProps={{ readOnly }}
                    sx={{ minWidth: 120 }}
                >
                    {options.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </TextField>
                <Box sx={{ m: 0.5, position: 'relative' }}>
                    <Fab
                        aria-label="save"
                        size="small"
                        color={error ? 'error' : 'primary'}
                        sx={{
                            ...buttonSx,
                            width: 18,
                            height: 18,
                            minHeight: 'unset',
                        }}
                        onClick={onSave}
                        disabled={loading || isValueEmpty}
                    >
                        {error ? <ErrorIcon sx={{ fontSize: 14 }} /> : success ? <CheckIcon sx={{ fontSize: 14 }} /> : <SaveIcon sx={{ fontSize: 14 }} />}
                    </Fab>
                    {loading && (
                        <CircularProgress
                            size={24}
                            sx={{
                                color: green[500],
                                position: 'absolute',
                                top: 1,
                                left: -1,
                                zIndex: 1,
                            }}
                        />
                    )}
                </Box>
                <Box sx={{ m: 0.5 }}>
                    <IconButton
                        aria-label="cancel"
                        color="error"
                        size="small"
                        sx={{ width: 18, height: 18 }}
                        onClick={onCancel}
                    >
                        <CloseIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                </Box>
            </Stack>
        </Tooltip>
    );
};

export default EditableSelect;
